import React, { Component } from 'react';
import { Button, Card, Avatar, Row, Col, Tag } from 'antd';
import { GettingStartedView } from '../../GettingStarted';
import { inject, observer } from 'mobx-react/index';
import moment from 'moment-timezone';

const { Meta } = Card;

@inject('store')
@observer
export class BotsListView extends Component {
    componentDidMount() {
        this.props.store.botConfigStore.getConfigurations();
        this.props.store.billingStore.getSubscriptions();
    }

    render() {
        const { timezone } = this.props.store.userStore.currentUser;
        let bots = Object.values(this.props.store.botStore.bots);
        bots = [...bots, ...this.props.store.botConfigStore.configurations];

        return (
            <div style={{ position: 'relative' }}>
                <h1>My Bots {this.renderNewBotButton()}</h1>

                {Object.values(bots).length ? null : <GettingStartedView />}
                <Row gutter={24}>
                    {Object.values(bots).map((bot, i) => {
                        const subscription = this.props.store.billingStore.subscriptions.find(
                            sub => sub.bot_id === (bot._id || bot.pool_id)
                        );

                        const legacySub = this.props.store.botStore.poolBindings[bot.pool_id];
                        const legacyActive =
                            (legacySub && Date.now() < legacySub.sub_expiry) || false;
                        return (
                            <Col md={6} key={i}>
                                <Card
                                    onClick={() =>
                                        this.props.history.push(
                                            `/a/${bot.type || 'bot'}/${bot._id || bot.id}/${
                                                bot.type === 'apex' ? 'positions' : 'trade'
                                            }`
                                        )
                                    }
                                    key={bot.id}
                                    bordered={false}
                                    style={{ marginBottom: 15 }}
                                    className={'bot-card'}
                                >
                                    <Meta
                                        avatar={<Avatar src={`/exchanges/${bot.exchange}.png`} />}
                                        title={bot.name}
                                        description={
                                            <div>
                                                <div>
                                                    <b>Status: &nbsp;</b>
                                                    <Tag>
                                                        {(this.props.store.botStore.poolBindings[
                                                            bot.pool_id
                                                        ] &&
                                                            this.props.store.botStore.poolBindings[
                                                                bot.pool_id
                                                            ].status) ||
                                                            bot.status ||
                                                            'UNKNOWN'}{' '}
                                                    </Tag>
                                                </div>
                                                <div>
                                                    <b>Subscription: </b>
                                                    {!subscription && !legacySub ? (
                                                        <span>No Subscription</span>
                                                    ) : subscription ? (
                                                        subscription.status
                                                    ) : (
                                                        <span>
                                                            {legacyActive
                                                                ? 'LEGACY SUB ACTIVE'
                                                                : 'EXPIRED'}
                                                        </span>
                                                    )}
                                                </div>
                                                <div>
                                                    <b>Renew Date: </b>
                                                    {!subscription && !legacySub ? (
                                                        <span>N/A</span>
                                                    ) : subscription ? (
                                                        moment(subscription.end_date)
                                                            .tz(timezone)
                                                            .format('DD/MM/YYYY')
                                                    ) : (
                                                        <span>
                                                            {moment(legacySub.sub_expiry)
                                                                .tz(timezone)
                                                                .format('DD/MM/YYYY')}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        }
                                    />
                                </Card>
                            </Col>
                        );
                    })}
                </Row>
            </div>
        );
    }

    renderNewBotButton() {
        return (
            <div style={{ position: 'absolute', right: 0, top: 0 }}>
                <Button onClick={() => this.props.history.push('/a/bots/new')} type="primary">
                    New Bot
                </Button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bots/List/index.js